import React, { useState, useRef, useEffect, useContext } from "react";
import styled from 'styled-components';
import ImageUploading from 'react-images-uploading';
import { getStoredUser } from '../../utils/safeStorage';
import AsyncSelect from 'react-select/async';
// Nota: Este componente usa styled-components para isolamento total de estilos

import { getCategorias, registerItem } from "../../services/api";
import PermissionGate from "../../services/PermissionGate";
import { useNavigate, useLocation } from "react-router-dom";

import InputMoney from "./InputMoney";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as AiIcons from 'react-icons/ai'
import * as SlIcons from 'react-icons/sl'
import { MdFastfood } from "react-icons/md";

import Loading from "react-loading";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';

import { SidebarContext } from "../../AppRoutes";

// ============================================
// STYLED COMPONENTS - LAYOUT RESPONSIVO
// ============================================

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: ${({ sidebar }) => (sidebar ? '250px' : '100px')};
    min-height: 100vh;
    background-color: rgb(247, 247, 247);
    transition: margin-left 150ms ease;

    @media (max-width: 880px) {
        margin-left: 0;
    }
`;

const ContentWrapper = styled.div`
    padding: 24px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 16px;
    }

    @media (max-width: 480px) {
        padding: 12px;
    }
`;

const PageHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 24px;

    h1 {
        font-size: 1.5rem;
        color: #333;
        margin: 0;
    }

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: stretch;

        h1 {
            text-align: center;
            font-size: 1.25rem;
        }
    }
`;

const ButtonsContainer = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        width: 100%;

        > div {
            flex: 1;
        }

        button {
            width: 100%;
            justify-content: center;
        }
    }
`;

const StepsIndicator = styled.div`
    display: flex;
    gap: 0;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 24px;

    @media (max-width: 480px) {
        flex-direction: column;
    }
`;

const StepItem = styled.div`
    flex: 1;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    color: ${({ active }) => (active ? 'rgb(49, 140, 213)' : '#ccc')};
    background: ${({ active }) => (active ? 'rgba(49, 140, 213, 0.05)' : 'transparent')};
    border-bottom: 3px solid ${({ active }) => (active ? 'rgb(49, 140, 213)' : 'transparent')};
    transition: all 0.2s ease;

    &:not(:last-child) {
        border-right: 1px solid #eee;
    }

    @media (max-width: 480px) {
        &:not(:last-child) {
            border-right: none;
            border-bottom: 1px solid #eee;
        }
    }
`;

const FormCard = styled.div`
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 24px;

    @media (max-width: 768px) {
        padding: 20px;
    }

    @media (max-width: 480px) {
        padding: 16px;
    }
`;

const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 280px;
    gap: 32px;
    align-items: start;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        gap: 24px;
    }
`;

const FormFields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }

    input {
        height: 45px;
        padding: 0 16px;
        border: none;
        border-radius: 10px;
        box-shadow: 1px 1px 6px lightgray;
        font-size: 14px;
        transition: outline 0.2s ease;

        &:focus {
            outline: 2px solid #4070f4;
        }

        &::placeholder {
            color: #aaa;
        }
    }

    .error {
        color: red;
        font-size: 12px;
        margin-top: 4px;
    }
`;

const TextAreaWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }

    textarea {
        width: 100%;
        height: 120px;
        padding: 12px 16px;
        border: none;
        border-radius: 10px;
        box-shadow: 1px 1px 6px lightgray;
        font-size: 14px;
        resize: vertical;
        font-family: inherit;

        &:focus {
            outline: 2px solid #4070f4;
        }

        &::placeholder {
            color: #aaa;
        }
    }

    .char-counter {
        text-align: right;
        font-size: 12px;
        color: #888;
    }
`;

const ImageUploadArea = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 900px) {
        order: -1;
    }
`;

const UploadBox = styled.div`
    width: 100%;
    max-width: 240px;
    min-height: ${({ hasImage }) => (hasImage ? 'auto' : '200px')};
    border: 2px ${({ hasImage }) => (hasImage ? 'solid #ddd' : 'dashed #4281FF')};
    border-radius: 12px;
    background: ${({ hasImage }) => (hasImage ? 'white' : 'rgb(250, 250, 250)')};
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${({ hasImage }) => (hasImage ? '0' : '20px')};
    transition: all 0.2s ease;
    text-align: center;
    overflow: hidden;

    &:hover {
        border-color: rgb(49, 140, 213);
        background: ${({ hasImage }) => (hasImage ? 'white' : 'rgba(49, 140, 213, 0.03)')};

        .icon-wrapper {
            background: rgb(49, 140, 213);

            svg {
                color: white;
            }
        }
    }

    .icon-wrapper {
        width: 70px;
        height: 70px;
        border-radius: 10px;
        border: 1px solid #98c5ea;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
        transition: all 0.2s ease;

        svg {
            font-size: 40px;
            color: rgb(49, 140, 213);
        }
    }

    .upload-title {
        font-size: 13px;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
    }

    .upload-hint {
        font-size: 11px;
        color: #888;
    }
`;

const ImagePreview = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px;

    img, .img-thumbnail {
        max-width: 180px !important;
        max-height: 160px !important;
        width: auto !important;
        height: auto !important;
        border-radius: 8px !important;
        object-fit: cover !important;
        display: block !important;
    }
`;

const ImageButtons = styled.div`
    display: flex;
    gap: 8px;

    button {
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 8px;
        background: #e8e8e8;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background 0.2s ease;

        &:hover {
            background: #57B4FF;

            svg {
                stroke: white;
            }
        }
    }
`;

const UploadInfo = styled.p`
    font-size: 11px;
    color: #888;
    text-align: center;
    margin-top: 12px;
`;

const ErrorMessage = styled.span`
    color: red;
    font-size: 12px;
    display: block;
    margin-top: 8px;
`;

const PriceSection = styled.div`
    margin-top: 8px;

    label {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        display: block;
        margin-bottom: 6px;
    }
`;

const SaveButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 20px;
    background: linear-gradient(135deg, rgb(49, 140, 213), rgb(79, 172, 254));
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 110px;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(49, 140, 213, 0.35);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

const BackButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 20px;
    background: white;
    color: #666;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 100px;

    &:hover {
        background: #f8f8f8;
        border-color: #ccc;
    }
`;

// ============================================
// COMPONENTE PRINCIPAL
// ============================================

const Item = () => {
    const { t } = useTranslation('categorias');
    const location = useLocation();
    const { infoCategoria, modelo } = location.state || {};

    const userParse = getStoredUser();
    const userID = userParse?._id;

    const empresa = localStorage.getItem('empresa')
    const empresaParse = JSON.parse(empresa)
    const idEmpresa = empresaParse.id_empresa;

    const descriptionRef = useRef();
    const { sidebar } = useContext(SidebarContext);

    const [valuePreco, setValuePreco] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const INITIAL_DATA = {
        value: "",
        label: t('addItemModal.categoryPlaceholder'),
    };
    const [selectData, setselectData] = useState(infoCategoria ?? INITIAL_DATA);

    const mapResponseToValuesAndLabels = (data) => ({
        value: data._id,
        label: data.title,
    });

    async function callApi(value) {
        const data = await getCategorias()
            .then((response) => response.data.categorias)
            .then((response) => {
                if ((modelo?.value === 2 || modelo === 2)) {
                    return response.filter((categoria) => (categoria.modelo?.value === 2 || categoria.modelo === 2));
                } else if ((modelo?.value === 1 || modelo === 1) || !modelo) {
                    return response.filter((categoria) => (categoria.modelo?.value === 1 || categoria.modelo === 1) || !categoria.modelo);
                }
                return response;
            })
            .then((response) => response.sort((a, b) => a.order - b.order))
            .then((response) => response.map(mapResponseToValuesAndLabels))
            .then((response) => response.filter((i) => i.label.toLowerCase().includes(value.toLowerCase())));

        return data;
    }

    const [errImg] = React.useState(false);
    const [images, setImages] = React.useState([]);
    const [imageError, setImageError] = useState('');
    const maxNumber = 1;
    const maxMbFileSize = 2 * 1024 * 1024;

    const onChangeImg = (imageList, addUpdateIndex) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log(imageList, addUpdateIndex);

        // Validar se a imagem foi carregada corretamente
        if (imageList && imageList.length > 0) {
            const image = imageList[0];

            // Verificar se o data_url está presente e é válido
            if (!image.data_url || image.data_url === '' || !image.data_url.startsWith('data:image')) {
                toast.error(t('addItemModal.imageCloudError'), {
                    autoClose: 6000
                });
                setImageError(t('addItemModal.imageNotAvailable'));
                setImages([]);
                return;
            }

            // Verificar se o tamanho do data_url é muito pequeno (indicando arquivo não carregado)
            if (image.data_url.length < 100) {
                toast.error(t('addItemModal.imageInvalidError'), {
                    autoClose: 5000
                });
                setImageError(t('addItemModal.imageCorrupted'));
                setImages([]);
                return;
            }
        }

        setImageError('');
        setImages(imageList);
    };

    useEffect(() => {
        (async () => {})();
    }, []);

    const SignUpSchema = Yup.object().shape({
        title: Yup.string().required(t('addItemModal.required')),
        vinculo_categoria: !selectData.value && Yup.string().required(t('addItemModal.required')),
    });

    const formik = useFormik({
        validationSchema: SignUpSchema,
        validateOnBlur: false,
        validateOnChange: false,
        initialValues: {
            vinculo_categoria: "",
            title: "",
            preco: 0,
        },
        onSubmit: (values) => {
            setIsSubmitting(true);
            const description = descriptionRef.current.value;
            const title = values.title;
            const price = values.preco;
            handleSubmitAPI(title, description, price);
        },
    });

    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/list-categoria");
    }

    const handleSubmitAPI = (title, description, price) => {
        const createdBy = userID;
        const out = false;
        const category_item_id = selectData.value;
        const category_item_title = selectData.label;
        const disponibilidade = 'sempre';
        const type = (modelo?.value === 2 || modelo === 2) ? "pizza" : "simples";

        registerItem(createdBy, idEmpresa, category_item_id, category_item_title, title, description, out, images, price, disponibilidade, type).then(cast => {
            if (cast.status === 201) {
                toast(cast.data.msg, { autoClose: 5000, type: "success" });
                navigate("/list-categoria");
            } else {
                toast(cast.data.msg, { autoClose: 5000, type: "error" });
            }
        }).catch(err => {
            const msg = err.response.data.msg;
            toast(msg, { autoClose: 5000, type: "error" });
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    const [valueDescricao, setValueDescricao] = useState('');

    const handleMaxCharDescricao = (e) => {
        const newValue = e.target.value;
        if (newValue.length <= 1000) {
            setValueDescricao(newValue);
        }
    };

    const onChange = (event, nameObject, isNumber) => {
        setValuePreco(isNumber ? Number(event.target.value) : event.target.value);
        formik.setFieldValue("preco", isNumber ? Number(event.target.value) : event.target.value);
    };

    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    return (
        <PermissionGate permissions={['default']}>
            <PageContainer sidebar={sidebar}>
                <ContentWrapper>
                    <form onSubmit={formik.handleSubmit}>
                        {/* Header com título e botões */}
                        <PageHeader>
                            <h1>{(modelo?.value === 2 || modelo === 2) ? t('addItemModal.titlePizza') : t('addItemModal.title')}</h1>
                            <ButtonsContainer>
                                <SaveButton type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <Loading type="spin" color="white" height={20} width={20} />
                                    ) : (
                                        <>
                                            <AiIcons.AiOutlineSave style={{ fontSize: "18px" }} />
                                            <span>{t('actions.save')}</span>
                                        </>
                                    )}
                                </SaveButton>
                                <BackButton type="button" onClick={handleBack}>
                                    <SlIcons.SlActionUndo style={{ color: "#ff4c4c", fontSize: "16px" }} />
                                    <span>{t('actions.back')}</span>
                                </BackButton>
                            </ButtonsContainer>
                        </PageHeader>

                        {/* Indicador de Etapas */}
                        <StepsIndicator>
                            <StepItem active>1. {(modelo?.value === 2 || modelo === 2) ? t('listItemPage.stepSize') : t('listItemPage.stepItem')}</StepItem>
                            <StepItem>2. {t('listItemPage.stepAdditionals')}</StepItem>
                        </StepsIndicator>

                        {/* Card do Formulário */}
                        <FormCard>
                            <FormGrid>
                                {/* Campos do Formulário */}
                                <FormFields>
                                    {/* Categoria */}
                                    <InputGroup>
                                        <label>{t('addItemModal.category')}<span style={{ color: "red" }}>*</span></label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={callApi}
                                            onChange={(data) => setselectData(data)}
                                            value={selectData}
                                            defaultOptions
                                            id="vinculo_categoria"
                                            name="vinculo_categoria"
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    height: "45px",
                                                    border: "none",
                                                    outline: state.isFocused ? '2px solid #4070f4' : '0',
                                                    borderRadius: "10px",
                                                    boxShadow: "1px 1px 6px lightgray",
                                                    fontSize: "14px",
                                                }),
                                                input: (style) => ({
                                                    ...style,
                                                    color: "black",
                                                }),
                                                singleValue: (baseStyles) => ({
                                                    ...baseStyles,
                                                    color: selectData.value ? "black" : "gray",
                                                }),
                                                valueContainer: (baseStyles) => ({
                                                    ...baseStyles,
                                                    fontWeight: "normal",
                                                    paddingLeft: "12px",
                                                }),
                                                option: (styles) => ({
                                                    ...styles,
                                                    fontWeight: "normal",
                                                    color: "black",
                                                }),
                                            }}
                                        />
                                        {formik.errors.vinculo_categoria && (
                                            <div className="error">{formik.errors.vinculo_categoria}</div>
                                        )}
                                    </InputGroup>

                                    {/* Nome do Item */}
                                    <InputGroup>
                                        <label>{(modelo?.value === 2 || modelo === 2) ? t('listItemPage.sizeName') : t('addItemModal.itemName')}<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            placeholder={(modelo?.value === 2 || modelo === 2) ? t('addItemModal.itemNamePlaceholderPizza') : t('addItemModal.itemNamePlaceholder')}
                                            id="title"
                                            type="text"
                                            name="title"
                                            onChange={formik.handleChange}
                                            value={formik.values.title}
                                        />
                                        {formik.errors.title && (
                                            <div className="error">{formik.errors.title}</div>
                                        )}
                                    </InputGroup>

                                    {/* Descrição */}
                                    <TextAreaWrapper>
                                        <label>{t('addItemModal.description')}</label>
                                        <textarea
                                            placeholder={t('addItemModal.descriptionPlaceholder')}
                                            value={valueDescricao}
                                            onChange={handleMaxCharDescricao}
                                            maxLength="1000"
                                            ref={descriptionRef}
                                        />
                                        <div className="char-counter">{valueDescricao.length}/1000</div>
                                    </TextAreaWrapper>

                                    {/* Preço (apenas se não for pizza) */}
                                    {modelo?.value !== 2 && (
                                        <PriceSection>
                                            <label>{t('addItemModal.price')}</label>
                                            <InputMoney
                                                onChange={(event) => onChange(event, 'price', true)}
                                                value={valuePreco}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                style={{
                                                    outline: isFocused ? '2px solid #4070f4' : 'none',
                                                    borderRadius: 10,
                                                    boxShadow: '1px 1px 6px lightgray',
                                                }}
                                                placeholder={t('addItemModal.price')}
                                            />
                                            {formik.errors.preco && (
                                                <div className="error">{formik.errors.preco}</div>
                                            )}
                                        </PriceSection>
                                    )}
                                </FormFields>

                                {/* Upload de Imagem */}
                                <ImageUploadArea>
                                    <ImageUploading
                                        multiple
                                        value={images}
                                        onChange={onChangeImg}
                                        maxNumber={maxNumber}
                                        maxFileSize={maxMbFileSize}
                                        acceptType={["jpg", "jpeg", "png", "webp"]}
                                        dataURLKey="data_url"
                                    >
                                        {({
                                            imageList,
                                            onImageUpload,
                                            onImageUpdate,
                                            onImageRemove,
                                            isDragging,
                                            dragProps,
                                            errors
                                        }) => (
                                            <>
                                                <UploadBox
                                                    onClick={onImageUpload}
                                                    hasImage={imageList.length > 0}
                                                    {...dragProps}
                                                >
                                                    {imageList.length > 0 ? (
                                                        <ImagePreview>
                                                            <img
                                                                src={imageList[0]['data_url']}
                                                                alt="Preview"
                                                                style={{
                                                                    maxWidth: '180px',
                                                                    maxHeight: '160px',
                                                                    borderRadius: '8px',
                                                                    objectFit: 'cover'
                                                                }}
                                                            />
                                                            <ImageButtons>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => { e.stopPropagation(); onImageUpdate(0); }}
                                                                    title={t('addItemModal.imageChange')}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5A5A5A" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                                                        <polyline points="1 4 1 10 7 10" />
                                                                        <polyline points="23 20 23 14 17 14" />
                                                                        <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" />
                                                                    </svg>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => { e.stopPropagation(); onImageRemove(0); }}
                                                                    title={t('addItemModal.imageRemove')}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5A5A5A" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                                                                        <polyline points="3 6 5 6 21 6" />
                                                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                                        <line x1={10} y1={11} x2={10} y2={17} />
                                                                        <line x1={14} y1={11} x2={14} y2={17} />
                                                                    </svg>
                                                                </button>
                                                            </ImageButtons>
                                                        </ImagePreview>
                                                    ) : (
                                                        <>
                                                            <div className="icon-wrapper">
                                                                <MdFastfood />
                                                            </div>
                                                            <div className="upload-title">
                                                                {isDragging ? t('listItemPage.dropHere') : t('addItemModal.imageChoose')}
                                                            </div>
                                                            <div className="upload-hint">
                                                                {t('listItemPage.imageDragDropHint')}
                                                            </div>
                                                        </>
                                                    )}
                                                </UploadBox>

                                                {errors && (
                                                    <div style={{ textAlign: 'center', marginTop: 8 }}>
                                                        {errors.maxNumber && <ErrorMessage>{t('addItemModal.imageMaxNumber')}</ErrorMessage>}
                                                        {errors.acceptType && <ErrorMessage>{t('addItemModal.imageInvalidFormat')}</ErrorMessage>}
                                                        {errors.maxFileSize && <ErrorMessage>{t('addItemModal.imageMaxFileSize')}</ErrorMessage>}
                                                    </div>
                                                )}

                                                {errImg && <ErrorMessage>{t('listItemPage.imageRequired')}</ErrorMessage>}
                                                {imageError && <ErrorMessage>{imageError}</ErrorMessage>}
                                            </>
                                        )}
                                    </ImageUploading>
                                    <UploadInfo>{t('addItemModal.imageMaxSize')}</UploadInfo>
                                </ImageUploadArea>
                            </FormGrid>
                        </FormCard>
                    </form>
                </ContentWrapper>
            </PageContainer>
        </PermissionGate>
    );
};

export default Item;
